/*******************************************************************************************************
 **                                                                                                    **
 **                                             VARIABLES                                              **
 **                                                                                                    **
 *******************************************************************************************************/
const decodeMaxAttempts = 3;

let attemptedVinsInGarage = [];
let attemptedVinsVinVerification = [];
let attemptedVinsOEM = [];
let attemptedOEMVins = [];
let attemptedDecodedVins = [];
let attemptedDecodedLicensePlates = [];

let finalVinVerificationSubmissionVin = "";
let garageFirstVehicleData = "";
let themeName = "";
let autoSelectedColor = "";
let autoSelectedOption = "";
let storedDecodedVin = "";
let firstVehicleColor = "";
let decodedPaintedOptionPainted = "";
let decodedPaintedOptionPrice = "";
let licenseOptionMsg = "";
let vinOptionMsg = "";
let vinWord = "";
let licensePlateWord = "";
let troublesomeMakesGlobal = "";
let licenseGarageLatest = "";

let garageVinSubmissionBool = false;
let successfulVinVerificationVin = false;
let successfulVinDecoding = false;
let alreadyLogged = false;
let garageToCollections = false;
let decodedVINHasAvailableStock = false;
let autoSelectedBanned = false;
let isCurrentVehicleTroublesome = false;
let storedPaintOptionIsDTM = false;

const vinInputLibrary = document.querySelector("#vin-textbox");
const vinTextboxContainer = document.getElementById("vin-textbox-container");
const vinOptionLabel = document.getElementById("paint-code-vin-option");
const storedDecodedPaintCodeMsgGlobal = document.querySelector(
  ".stored-decoded-paint-msg"
);
const selectCodeOptionLabel = document.getElementById(
  "paint-code-select-code-option"
);
const licenseOptionLabel = document.getElementById("paint-code-license-option");
const storedOptionLabel = document.getElementById("paint-code-stored-option");
const failSafeSelectCodeOptionLabel = document.querySelector(
  ".select-code-fail-safe"
);
const checkboxStoredCodeText = document.querySelector(".checkbox-stored-code");

/*******************************************************************************************************
 **                                                                                                    **
 **                                           GARAGE LOGIC                                             **
 **                                                                                                    **
 *******************************************************************************************************/
document.addEventListener("easysearch_rendered", function () {
  console.log("easysearch_rendered event fired!");
  addCustomEasysearchBtn();
});

// Fallback: if event already fired before listener registered
if (window.easysearchWasRendered) {
  console.log(
    "easysearch_rendered event had already fired, running button logic immediately."
  );
  addCustomEasysearchBtn();
}

function addCustomEasysearchBtn() {
  const holders = document.querySelectorAll(".easysearch-holder");

  if (holders.length === 0) {
    console.log("[Global Library] No easysearch holders found, retrying...");
    setTimeout(addCustomEasysearchBtn, 500);
    return;
  }

  holders.forEach(function (holder) {
    // Prevent duplicate buttons
    if (holder.querySelector(".custom-easysearch-ymm-btn")) {
      return;
    }

    const actionsHolder = holder.querySelector(".easysearch-actions-holder");
    if (!actionsHolder) {
      console.log(
        "[Global Library] No .easysearch-actions-holder found, retrying..."
      );
      setTimeout(addCustomEasysearchBtn, 500);
      return;
    }

    const btnHolder = actionsHolder.querySelector(".easysearch-btn-holder");
    if (!btnHolder) {
      console.log(
        "[Global Library] No .easysearch-btn-holder found, retrying..."
      );
      setTimeout(addCustomEasysearchBtn, 500);
      return;
    }

    // Reference button for innerHTML
    const refBtn = document.getElementById("license-to-vin-btn");
    const btn = document.createElement("button");
    btn.type = "button";
    btn.id = "custom-easysearch-ymm-btn-id";
    btn.className = "custom-easysearch-ymm-btn";
    btn.innerHTML = refBtn ? refBtn.innerHTML : "Search";
    btn.disabled = true;
    holder.appendChild(btn);

    const anchor = btnHolder.querySelector("a");
    if (anchor) {
      function updateBtnState() {
        btn.disabled = !(
          anchor.href && !anchor.href.includes("javascript:void(0)")
        );
      }

      updateBtnState();

      const observer = new MutationObserver(() => updateBtnState());
      observer.observe(anchor, { attributes: true });

      btn.addEventListener("click", function () {
        if (btn.disabled) return;

        const year = document.getElementById("easysearch_field_4973");
        const make = document.getElementById("easysearch_field_4974");
        const model = document.getElementById("easysearch_field_4975");
        const submodel = document.getElementById("easysearch_field_28136");
        const engine = document.getElementById("easysearch_field_28137");

        updateEasysearchLocalStorageOrNavigate(
          year ?? null,
          make ?? null,
          model ?? null,
          submodel ?? null,
          engine ?? null,
          null,
          null,
          null
        );
        // Log to Google Sheets
        logGarageEventToSheets("dropdown", {});
      });
    }
  });
}

// This function is in place because old versions of the garage where in different formats.
// To keep things consistent, this function will update a person's garage to the new format
// if they still have the old format
function normalizeSearchTerm(entry) {
  // Migration for string entries
  if (typeof entry === "string") {
    return {
      ymm: entry,
      vin: null,
      paintCode: null,
      year: null,
      make: null,
      model: null,
      submodel: null,
      engine: null,
      state: null,
      plate: null,
      decodedByBumper: null,
      lastCollectionImage: null,
    };
  }

  // Migration for object entries with ymm as object
  if (entry && typeof entry.ymm === "object" && entry.ymm !== null) {
    entry = {
      ymm: entry.ymm.ymm || null,
      vin: entry.ymm.vin || null,
      paintCode: entry.ymm.paintCode || null,
      year: entry.ymm.year || null,
      make: entry.ymm.make || null,
      model: entry.ymm.model || null,
      submodel: entry.ymm.submodel || null,
      engine: entry.ymm.engine || null,
      state: entry.ymm.state || null,
      plate: entry.ymm.plate || null,
      decodedByBumper: entry.ymm.decodedByBumper || null,
      lastCollectionImage: entry.ymm.lastCollectionImage,
    };
  }

  return {
    ymm: entry.ymm,
    vin: entry.vin || null,
    paintCode: entry.paintCode || null,
    year: entry.year || null,
    make: entry.make || null,
    model: entry.model || null,
    submodel: entry.submodel || null,
    engine: entry.engine || null,
    state: entry.state || null,
    plate: entry.plate || null,
    decodedByBumper: entry.decodedByBumper || null,
    lastCollectionImage: entry.lastCollectionImage || null,
  };
}

function getSearchTerms() {
  let terms = JSON.parse(localStorage.getItem("searchTerms")) || [];
  terms = terms.map(normalizeSearchTerm);

  // Save back (migration)
  // We do this because a user may have an outdated searchTerms format -- therefore it must be updated with normalizeSearchTerm
  // Once normalized we rewrite it to localstorage to ensure it is always to most up to date format
  localStorage.setItem("searchTerms", JSON.stringify(terms));
  return terms;
}

function setSearchTerms(terms) {
  const uniqueTerms = [];
  const seen = new Set();
  const currentPage = window.location.href || "";
  for (const term of terms) {
    const normalized = normalizeSearchTerm(term);
    const trimmedYmm = normalized.ymm.trim();
    if (!seen.has(trimmedYmm)) {
      uniqueTerms.push({
        ...normalized,
        ymm: trimmedYmm,
        currentPage: currentPage,
        lastCollectionImage: "",
      });
      seen.add(trimmedYmm);
    }
  }
  localStorage.setItem("searchTerms", JSON.stringify(uniqueTerms));
}

// --- moveVehicleToFront migrated from garage-script.liquid ---
function moveVehicleToFront(vehicleData) {
  let currentSearchTerms = getSearchTerms();
  // vehicleData can be a string (ymm) or an object
  let ymm = typeof vehicleData === "string" ? vehicleData : vehicleData.ymm;

  let state = typeof vehicleData === "string" ? null : vehicleData.state;
  let plate = typeof vehicleData === "string" ? null : vehicleData.plate;

  // Find index where ymm matches exactly, or is contained in obj.ymm, or obj.ymm is contained in ymm
  let vehicleIndex = currentSearchTerms.findIndex(
    (obj) => obj.ymm === ymm || obj.ymm.includes(ymm) || ymm.includes(obj.ymm)
  );
  let vehicleObj;
  if (vehicleIndex > -1) {
    vehicleObj = currentSearchTerms.splice(vehicleIndex, 1)[0];
    // If either ymm contains the other, set ymm to the longer one
    if (vehicleObj.ymm !== ymm) {
      if (vehicleObj.ymm.length < ymm.length) {
        vehicleObj.ymm = ymm;
      }
    }
  } else {
    vehicleObj = normalizeSearchTerm(vehicleData);
  }

  // If currentSearchTerms.state does not exist add it
  if (state) {
    vehicleObj.state = state;
  }

  if (plate) {
    vehicleObj.plate = plate;
  }
  currentSearchTerms.unshift(vehicleObj);
  if (currentSearchTerms.length > 5) currentSearchTerms.pop();
  setSearchTerms(currentSearchTerms);
  return currentSearchTerms;
}

async function setSelectValueWhenReady(selectId, value, timeout = 3000) {
  const select = document.getElementById(selectId);
  let newValue = "";
  if (!select) return newValue;
  const start = Date.now();
  return new Promise((resolve) => {
    function trySet() {
      const match = Array.from(select.options).find(
        (opt) => opt.value.toLowerCase().trim() === value.toLowerCase().trim()
      );
      if (match) {
        select.value = match.value;
        newValue = match.value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
        resolve(newValue);
      } else if (Date.now() - start > timeout) {
        resolve(newValue); // Timed out, value not set
      } else {
        setTimeout(trySet, 50);
      }
    }
    trySet();
  });
}

function setFitmentObject(obj) {
  localStorage.setItem("easysearch-preselect-fitment", JSON.stringify(obj));
  localStorage.setItem("easysearch-preselect", JSON.stringify(obj));
}

function updateEasysearchLocalStorageOrNavigate(
  year,
  make,
  model,
  submodel,
  engine,
  vin,
  paintCode,
  decodedByBumper,
  lastCollectionImage
) {
  let anchor = null;
  const holder = document.querySelector(".easysearch-holder");
  const actionsHolder = holder?.querySelector(".easysearch-actions-holder");
  if (actionsHolder) {
    const btnHolder = actionsHolder.querySelector(".easysearch-btn-holder");
    if (btnHolder) {
      anchor = btnHolder.querySelector("a");
    }
  }

  const fields = [year, make, model, submodel, engine];
  const yearVal = year && year.value ? year.value.trim() : "";
  const makeVal = make && make.value ? make.value.trim() : "";
  const modelVal = model && model.value ? model.value.trim() : "";
  const submodelVal = submodel && submodel.value ? submodel.value.trim() : "";
  const engineVal = engine && engine.value ? engine.value.trim() : "";
  const vinVal = vin && vin.value ? vin.value.trim() : "";
  const paintCodeVal =
    paintCode && paintCode.value ? paintCode.value.trim() : "";
  const ymm = [yearVal, makeVal, modelVal, submodelVal, engineVal]
    .filter(Boolean)
    .join(" ");

  const isProductPage = window.location.pathname.includes("/products/");
  updateSearchTerms(
    ymm,
    yearVal,
    makeVal,
    modelVal,
    submodelVal,
    engineVal,
    vinVal,
    paintCodeVal,
    decodedByBumper,
    lastCollectionImage
  );
  if (isProductPage) {
    updateProductPageFitment(ymm, fields, anchor);
  } else {
    // window.location.href = anchor?.href;
    const url = new URL(anchor.href);
    window.location.href = url.pathname + url.search + url.hash;
  }
}

function updateProductPageFitment(ymm, fields, anchor) {
  let fitmentValue = "";
  const easySearchBtnSearch = document.querySelector(".easysearch-btn-search");
  let expires = Date.now() + 365 * 24 * 60 * 60 * 1000;
  // Build fitmentValue from the longest non-empty prefix of fields
  let prefix = [];
  for (let f of fields) {
    if (!f || f.value === "") {
      break;
    }
    prefix.push(f);
  }
  if (prefix.length === 0) {
    console.warn("Aborting fitmentValue creation: all fields are empty.");
    return;
  }
  fitmentValue = prefix
    .map((f) => f.value + "easysearch-preselect-delimiter")
    .join("");
  const fitmentObject = {
    value: fitmentValue,
    expires: expires.toString(),
  };
  setFitmentObject(fitmentObject);

  // Save current search parameters to localStorage or backend
  easysearch.saveSearchParams(easySearchBtnSearch);
  easysearch.addPropertyToProductForm();
  // Get the fitment widget element and the URL to load fitment results
  const fitWidget = document.querySelector(".easysearch-fitment-widget");
  const fitmentUrl = anchor?.href;

  // Function to trigger the fitment widget toggle after EasySearch is ready
  function triggerFitmentWidget() {
    if (
      window.easysearch &&
      typeof easysearch.fitmentToggleWidget === "function" &&
      fitWidget &&
      fitmentUrl
    ) {
      easysearch.fitmentToggleWidget(fitWidget, fitmentUrl);
      document.removeEventListener(
        "easysearch_init_native_search_page",
        triggerFitmentWidget
      );
    }
  }

  document.addEventListener(
    "easysearch_init_native_search_page",
    triggerFitmentWidget
  );

  if (
    window.easysearch &&
    typeof easysearch.fitmentToggleWidget === "function"
  ) {
    easysearch.fitmentToggleWidget(fitWidget, fitmentUrl);
  }

  toggleGaragePopup();
  const hiddenEasysearchEl = document.querySelector(
    ".easysearch-fitment-search-widget"
  );
  const failOrSuccessEasysearchEl = document.querySelector(
    ".easysearch-fitment-holder"
  );
  if (
    hiddenEasysearchEl &&
    !hiddenEasysearchEl.classList.contains("easysearch-hidden")
  ) {
    hiddenEasysearchEl.classList.add("easysearch-hidden");
  }
  if (
    failOrSuccessEasysearchEl &&
    failOrSuccessEasysearchEl.classList.contains("easysearch-hidden")
  ) {
    failOrSuccessEasysearchEl.classList.remove("easysearch-hidden");
  }
}

function updateSearchTerms(
  ymm,
  yearVal,
  makeVal,
  modelVal,
  submodelVal,
  engineVal,
  vinVal,
  paintCodeVal,
  decodedByBumper,
  lastCollectionImage
) {
  // Custom deduplication and update logic
  let searchTerms = getSearchTerms();
  let foundIdx = searchTerms.findIndex(
    (term) =>
      term.year === yearVal && term.make === makeVal && term.model === modelVal
  );

  // Found a match on year, make, model
  if (ymm && foundIdx > -1) {
    let updated = false;
    // Update submodel if incoming is more specific
    if (
      submodelVal &&
      (searchTerms[foundIdx].submodel === null ||
        searchTerms[foundIdx].submodel === "" ||
        searchTerms[foundIdx].submodel === undefined)
    ) {
      searchTerms[foundIdx].submodel = submodelVal;
      updated = true;
    }
    // Update engine if incoming is more specific
    if (
      engineVal &&
      (searchTerms[foundIdx].engine === null ||
        searchTerms[foundIdx].engine === "" ||
        searchTerms[foundIdx].engine === undefined)
    ) {
      searchTerms[foundIdx].engine = engineVal;
      updated = true;
    }
    // Update VIN if it doesn't already exist
    if (
      vinVal &&
      (searchTerms[foundIdx].vin === null ||
        searchTerms[foundIdx].vin === "" ||
        searchTerms[foundIdx].vin === undefined)
    ) {
      searchTerms[foundIdx].vin = vinVal;
      updated = true;
    }
    // Update paintcode if it doesn't already exist
    if (
      paintCodeVal &&
      (searchTerms[foundIdx].paintCode === null ||
        searchTerms[foundIdx].paintCode === "" ||
        searchTerms[foundIdx].paintCode === undefined)
    ) {
      searchTerms[foundIdx].paintCode = paintCodeVal;
      // Update the decodedByBumper here too
      searchTerms[foundIdx].decodedByBumper = decodedByBumper;
      updated = true;
    }
    // If both submodel and engine already match, do nothing
    if (
      !updated &&
      (searchTerms[foundIdx].submodel === submodelVal ||
        (!submodelVal &&
          (searchTerms[foundIdx].submodel === null ||
            searchTerms[foundIdx].submodel === "" ||
            searchTerms[foundIdx].submodel === undefined))) &&
      (searchTerms[foundIdx].engine === engineVal ||
        (!engineVal &&
          (searchTerms[foundIdx].engine === null ||
            searchTerms[foundIdx].engine === "" ||
            searchTerms[foundIdx].engine === undefined)))
    ) {
      // Do nothing
    } else if (updated) {
      // Rebuild ymm string with new details
      const parts = [
        searchTerms[foundIdx].year,
        searchTerms[foundIdx].make,
        searchTerms[foundIdx].model,
        searchTerms[foundIdx].submodel,
        searchTerms[foundIdx].engine,
      ].filter(Boolean); // remove null/undefined/empty
      searchTerms[foundIdx].ymm = parts.join(" ");

      // move the update car to front
      const [updatedCar] = searchTerms.splice(foundIdx, 1);
      searchTerms.unshift(updatedCar);
      setSearchTerms(searchTerms);
    } else {
      // If submodel/engine are different, add as new entry
      const newTerm = normalizeSearchTerm({
        ymm,
        vin: vinVal,
        paintCode: paintCodeVal,
        year: yearVal,
        make: makeVal,
        model: modelVal,
        submodel: submodelVal,
        engine: engineVal,
        decodedByBumper: decodedByBumper,
        lastCollectionImage: lastCollectionImage
      });
      searchTerms.unshift(newTerm);
      if (searchTerms.length > 5) searchTerms.splice(5);
      setSearchTerms(searchTerms);
    }

    // This is a new entry (did not find a match in garage)
  } else if (ymm) {
    // No match on year, make, model, so add new
    const newTerm = normalizeSearchTerm({
      ymm,
      vin: vinVal,
      paintCode: paintCodeVal,
      year: yearVal,
      make: makeVal,
      model: modelVal,
      submodel: submodelVal,
      engine: engineVal,
      decodedByBumper: decodedByBumper,
      lastCollectionImage: lastCollectionImage
    });
    searchTerms.unshift(newTerm);
    // if (searchTerms.length > 5) searchTerms.pop();
    // use splice to keep the limit
    if (searchTerms.length > 5) searchTerms.splice(5);
    setSearchTerms(searchTerms);
  }
}

function refactorModels(make, model) {
  let refactoredModel = model;
  let capMake = make.toUpperCase();
  let capModel = model.toUpperCase();
  // Special cases:

  // Chromedata returns the word mazda along with the model type.
  // e.g. Mazda3 instead of 3
  if (refactoredModel.includes("Mazda")) {
    // For the case where it is a hatchback, will look like Mazda3 Hatchback, pull the first word
    refactoredModel = refactoredModel.split(" ")[0];
    refactoredModel = refactoredModel.replace("Mazda", "");
  }

  // Chromedata can return the submodel along with subaru submodels.
  // e.g. WRX STI instead of WRX
  if (capMake === "SUBARU" && capModel.includes("WRX")) {
    // Just take the first word in this case
    refactoredModel = refactoredModel.split(" ")[0];
  }

  if (capMake === "LEXUS") {
    refactoredModel = refactoredModel.replace(" ", "");
  }

  return refactoredModel;
}

async function updateGarageAndNavigate(
  year,
  make,
  model,
  submodel,
  engine,
  vin,
  paintCode,
  state,
  plate,
  decodedByBumper
) {
  const refactoredModel = refactorModels(make, model);

  const yearVal = await setSelectValueWhenReady(
    "easysearch_field_4973",
    year || ""
  );
  const makeVal = await setSelectValueWhenReady(
    "easysearch_field_4974",
    make || ""
  );
  const modelVal = await setSelectValueWhenReady(
    "easysearch_field_4975",
    refactoredModel || ""
  );
  const submodelVal = await setSelectValueWhenReady(
    "easysearch_field_28136",
    submodel || ""
  );
  const engineVal = await setSelectValueWhenReady(
    "easysearch_field_28137",
    engine || ""
  );

  let localPaintCode = null;

  if (!isCurrentVehicleTroublesome) {
    localPaintCode = paintCode;
  }

  if (yearVal === "" || makeVal === "" || modelVal === "") {
    return false;
  }

  let formattedYmm = "";
  if (submodelVal && engineVal) {
    formattedYmm = `${yearVal} ${makeVal} ${modelVal} ${submodelVal || ""} ${engineVal || ""}`;
  } else if (submodelVal && !engineVal) {
    formattedYmm = `${yearVal} ${makeVal} ${modelVal} ${submodelVal || ""}`;
  } else {
    formattedYmm = `${yearVal} ${makeVal} ${modelVal}`;
  }

  moveVehicleToFront({
    ymm: formattedYmm,
    vin: vin || null,
    paintCode: localPaintCode || null,
    year: yearVal || null,
    make: makeVal || null,
    model: modelVal || null,
    submodel: submodelVal || null,
    engine: engineVal || null,
    state: state || null,
    plate: plate || null,
    decodedByBumper: decodedByBumper || null,
  });
  if (!window.location.pathname.includes("/products/")) {
    const btnHolder = document.querySelector(".easysearch-btn-holder");
    if (btnHolder) {
      const anchor = btnHolder.querySelector("a");
      if (anchor) {
        const url = new URL(anchor.href);
        if (anchor.href && !anchor.href.includes("javascript:void(0)")) {
          window.location.href = url.pathname + url.search + url.hash;
        }
      }
    }
  } else {
    updateEasysearchLocalStorageOrNavigate(
      yearVal,
      makeVal,
      modelVal,
      submodelVal,
      engineVal,
      vin,
      paintCode,
      decodedByBumper
    );
    // If on product page and paint option is available in local storage, update paint
    // options radio buttons
    firstVehicleColor = handleInsertLocalStoragePaintOption();
  }
  return true;
}

// Used for generating the correct filtered URL for non compatible vehicles
function updateGarageFirstVehicleData() {
  const vehicleDataContainer = document.querySelector(
    ".vehicle-item-container.first-vehicle-item-container .vehicle-browse-catalog-container strong[data-vehicle]"
  );
  const notCompatibleBtnContainer = document.querySelector(
    ".not-compatible-button"
  );
  if (vehicleDataContainer) {
    garageFirstVehicleData = vehicleDataContainer.getAttribute("data-vehicle");
  }
  if (!garageFirstVehicleData) {
    if (notCompatibleBtnContainer)
      notCompatibleBtnContainer.style.display = "none";
  } else {
    if (notCompatibleBtnContainer)
      notCompatibleBtnContainer.style.display = "block";
  }
}

/*******************************************************************************************************
 **                                                                                                    **
 **                                             UTILITIES                                              **
 **                                                                                                    **
 *******************************************************************************************************/

async function getIpAddress() {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip; // Returns the client's public IP
  } catch (error) {
    console.error("Error fetching IP address:", error);
    return null;
  }
}

function setVinDecoderInputValue(storedVinMsg, vinInputBox, vinSubmitBtn) {
  const garageSearchTerms = getSearchTerms();
  if (garageSearchTerms && garageSearchTerms[0] && garageSearchTerms[0].vin) {
    const vin = garageSearchTerms[0].vin;
    const ymm = garageSearchTerms[0].ymm || "";
    if (storedVinMsg) {
      storedVinMsg.style.display = "block";
      if (ymm === "") {
        storedVinMsg.textContent = `Using VIN: ${vin}`;
      } else {
        storedVinMsg.textContent = `Using ${vin} for your ${ymm}`;
      }
      vinInputBox.value = vin;
      vinSubmitBtn.disabled = false;
    }
  }
}

function removeVinDecoderInputValue(storedVinMsg, vinInputBox, vinSubmitBtn) {
  const garageSearchTerms = getSearchTerms();
  if (garageSearchTerms && garageSearchTerms[0] && garageSearchTerms[0].vin) {
    if (storedVinMsg) {
      storedVinMsg.style.display = "none";
      storedVinMsg.textContent = "";
      vinInputBox.value = "";
      vinSubmitBtn.disabled = true;
    }
  }
}

/*
    functionLocation - 1 = Garage
    functionLocation - 2 = Vin Verification
*/
// Function to handle VIN change
function handleVinChange(event, functionLocation, errorMsg) {
  let vinInput = event.target.value.toUpperCase();
  const filteredValue = vinInput.replace(
    /[IOQ\s:;()!@#$%^?'"&*\-_=+.`~<>{}\[\]|,\/\\]/gi,
    ""
  );
  const truncatedValue = filteredValue.slice(0, 17);

  event.target.value = truncatedValue;

  if (functionLocation === 1) {
    if (attemptedVinsInGarage.length) {
      for (let i = 0; i < attemptedVinsInGarage.length; i++) {
        if (
          attemptedVinsInGarage[i].toUpperCase() ===
          truncatedValue.toUpperCase()
        ) {
          document.querySelector(".errorMessageVIN").style.visibility =
            "visible";
          document.querySelector(".errorMessageVIN").innerHTML =
            "VIN already searched. Please try a different VIN";
          document.getElementById("vin-to-collection-btn").disabled = true;
          return;
        } else {
          document.querySelector(".errorMessageVIN").style.visibility =
            "hidden";
        }
      }
    }

    if (truncatedValue.length === 17) {
      document.getElementById("vin-to-collection-btn").disabled = false;
    } else {
      document.getElementById("vin-to-collection-btn").disabled = true;
    }

    if (vinInput !== filteredValue) {
      alert(errorMsg);
    }
  } else if (functionLocation === 2) {
    if (attemptedVinsVinVerification.length) {
      for (let i = 0; i < attemptedVinsVinVerification.length; i++) {
        if (
          attemptedVinsVinVerification[i].toUpperCase() ===
          truncatedValue.toUpperCase()
        ) {
          document.querySelector(
            ".vin-verification-submission-failed-message"
          ).style.display = "block";
          document.querySelector(
            ".vin-verification-submission-failed-message"
          ).innerHTML = "VIN already searched. Please try a different VIN";
          // document.getElementById('vin-to-collection-btn').disabled = true;
          return true;
        } else {
          document.querySelector(
            ".vin-verification-submission-failed-message"
          ).style.display = "none";
        }
      }
    }

    if (truncatedValue.length === 17) {
      document.getElementById("vin-to-collection-btn").disabled = false;
    } else {
      document.getElementById("vin-to-collection-btn").disabled = true;
    }

    if (vinInput !== filteredValue) {
      alert(errorMsg);
    }
  } else if (functionLocation === 3) {
    if (attemptedDecodedVins.length) {
      for (let i = 0; i < attemptedDecodedVins.length; i++) {
        if (
          attemptedDecodedVins[i].toUpperCase() === truncatedValue.toUpperCase()
        ) {
          document.querySelector(
            ".vin-decoder-submission-failed-message"
          ).style.display = "block";
          document.querySelector(
            ".vin-decoder-submission-failed-message"
          ).innerHTML = "VIN already searched. Please try a different VIN";
          // document.getElementById('vin-to-collection-btn').disabled = true;
          return true;
        } else {
          document.querySelector(
            ".vin-decoder-submission-failed-message"
          ).style.display = "none";
        }
      }
    }

    if (truncatedValue.length === 17) {
      document.getElementById("vin-to-collection-btn").disabled = false;
    } else {
      document.getElementById("vin-to-collection-btn").disabled = true;
    }

    if (vinInput !== filteredValue) {
      alert(errorMsg);
    }
  }
}

function handleStateSelectChange(event, errorAlreadyAttempted, id) {
  const stateInput = event.target.value.toUpperCase();
  const licenseBtn = document.getElementById(id);
  const errorMessageLicense = document.querySelector(".errorMessageLicense");
  event.target.value = stateInput;
  if (
    attemptedDecodedLicensePlates.includes(
      stateInput + "-" + licenseGarageLatest
    )
  ) {
    licenseBtn.disabled = true;
    errorMessageLicense.style.visibility = "visible";
    errorMessageLicense.innerHTML = errorAlreadyAttempted;
    return;
  }
  if (errorMessageLicense.style.visibility === "visible")
    errorMessageLicense.style.visibility = "hidden";
  if (licenseGarageLatest.length > 0) {
    licenseBtn.disabled = false;
  } else {
    licenseBtn.disabled = true;
  }
}

function handleLicenseChange(
  event,
  functionLocation,
  errorMsg,
  errorAlreadyAttempted,
  stateDropdownClass,
  id
) {
  let licenseInput = event.target.value.toUpperCase();
  let sanitizedPlateInput = licenseInput
    ? licenseInput.replace(/[\s-]+/g, "").trim()
    : "";
  event.target.value = sanitizedPlateInput;
  const licenseBtn = document.getElementById(id);
  const errorMessageLicense = document.querySelector(".errorMessageLicense");
  const stateSelect = document.querySelector(stateDropdownClass);
  const state = stateSelect ? stateSelect.value : "";
  licenseGarageLatest = sanitizedPlateInput;
  if (
    attemptedDecodedLicensePlates.includes(state + "-" + sanitizedPlateInput)
  ) {
    licenseBtn.disabled = true;
    errorMessageLicense.style.visibility = "visible";
    errorMessageLicense.innerHTML = errorAlreadyAttempted;
    return;
  }
  if (errorMessageLicense.style.visibility === "visible")
    errorMessageLicense.style.visibility = "hidden";
  if (state.length && sanitizedPlateInput.length > 0) {
    licenseBtn.disabled = false;
  } else {
    licenseBtn.disabled = true;
  }
}

async function createCompanyProfile(
  companyName,
  firstName,
  lastName,
  email,
  phone,
  title,
  address,
  city,
  zipCode,
  stateAbbr,
  locationName,
  pdf,
  taxRegistrationId,
  typeText,
  reasonText
) {
  try {
    const response = await fetch(
      "https://tax-exemption-signup-505215902673.us-east5.run.app/createCustomerProfile",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          companyName,
          firstName,
          lastName,
          email,
          phone,
          title,
          address,
          city,
          zipCode,
          stateAbbr,
          locationName,
          pdf,
          taxRegistrationId,
          typeText,
          reasonText,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(
        `Error fetching order details. Status: ${response.status}. Message: ${response.statusText}.`
      );
    }
    const data = await response.json();
  } catch (error) {
    console.error("Error fetching vehicle data:", error);
  }
}

/*
    functionLocation - 1 = Garage
    functionLocation - 2 = Vin Verification
    functionLocation - 3 = Vin Decoder - Vin Lookup
    functionLocation - 4 = Vin Decoder - License Plate Lookup
    functionLocation - 5 = OEM
*/
async function fetchVehicleDataByVin(
  state,
  plate,
  vin,
  functionLocation,
  noResults,
  failed3times,
  searchBtn,
  tailoredSuccessMessage,
  failedAttemptMsg,
  remainingAttempts,
  troublesomeMakesColors,
  bumperdotcommake,
  allChromeDataMakes
) {
  const vinSearchBtn = document.getElementById("vin-to-collection-btn");
  const licenseToVinbtn = document.getElementById("license-to-vin-btn");
  const errorMessageVIN = document.querySelector(".errorMessageVIN");
  const errorMessageLicense = document.querySelector(".errorMessageLicense");
  let calculatedRemainingAttemptsVinVerification =
    decodeMaxAttempts - attemptedVinsVinVerification.length;
  let calculatedRemainingAttemptsVinDecoder =
    decodeMaxAttempts - attemptedDecodedVins.length;
  let calculatedRemainingAttemptsLicenseDecoder =
    decodeMaxAttempts - attemptedDecodedLicensePlates.length;
  const vinGuaranteeFetchingMsg = document.querySelector(
    ".vin-verification-fetching-vin-data"
  );
  const vinDecoderFetchingMsg = document.querySelector(
    ".vin-decoder-fetching-vin-data"
  );
  let partifyLocation = await getPartifyLocation();
  let parentUrl = window.location.href;
  let response = "";
  let data = "";
  let dataResult = "";
  let description = "";
  let vehicleError = false;
  let validVin = false;
  let validVehicleFound = false;
  let chromedatamake = false;
  let decodedByBumper = false;
  let exteriorColors = [];
  let colorCode = "";
  let year = "";
  let make = "";
  let model = "";
  let submodel = "";
  let engine = "";
  let ymm = "";
  let site = "";
  let styleId = "";
  let genericDesc = "";
  let fullDescription = "";
  let hex = "";
  let errorMessage = "";

  try {
    if (vinGuaranteeFetchingMsg)
      vinGuaranteeFetchingMsg.style.display = "block";
    if (vinDecoderFetchingMsg) vinDecoderFetchingMsg.style.display = "block";

    // Check if vin is empty.. if so, then license lookup failed
    if (vin.length === 17) {
      if (bumperdotcommake && bumperdotcommake === true) {
        response = await fetch(
          `https://bumperdotcom-api-345230973812.us-east5.run.app/bumperdotcom-api?vin=${vin}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );

        data = await response.json();

        if (!response.ok) {
          validVin = false;
          errorMessage = `Error fetching order details. Status: ${response.status}. Message: ${response.statusText}.`;
          throw new Error(
            `Error fetching order details. Status: ${response.status}`
          );
        }

        vehicleError = data.entities.vehicles.automobiles.length === 0;
        validVin = true;
        exteriorColors =
          data.entities.vehicles.automobiles[0]?.design?.colors || [];
        if (exteriorColors.length > 0) {
          let exteriorCounter = 0;
          exteriorColors.forEach((color) => {
            if (color.category === "Exterior") {
              if (exteriorCounter === 0) {
                colorCode = color.code || "";
              } else {
                colorCode = "";
              }
              exteriorCounter++;
            }
          });
          if (exteriorCounter > 1) {
            errorMessage = `Too many paint codes to determine`;
          }
        } else {
          errorMessage = `No exterior colors found for the provided VIN: ${vin}`;
        }
        description =
          data.entities.vehicles.automobiles[0]?.design?.current_color?.name ||
          "";
        year = data.entities.vehicles.automobiles[0]?.year || "";
        make = data.entities.vehicles.automobiles[0]?.make || "";
        model = data.entities.vehicles.automobiles[0]?.model || "";
        ymm = `${year} ${make} ${model}`.trim();
        site = "Bumper.com";
        genericDesc =
          data.entities.vehicles.automobiles[0]?.design?.current_color
            ?.generic_name || "";
        fullDescription =
          data.entities.vehicles.automobiles[0]?.design?.current_color?.name ||
          "";
        hex =
          data.entities.vehicles.automobiles[0]?.design?.current_color?.hex ||
          "";
        if (year !== "" && make !== "" && model !== "") {
          validVehicleFound = true;
        }

        // Toyota, Lexus, and Scion paint codes are always 3 digits but sometimes Bumper or Chromedata returns them as 4. 
        // e.g. Bumper === 0040, in reality it is 040.  So we take the last 3
        if (make.toLowerCase() === "toyota" || make.toLowerCase() === "lexus" || make.toLowerCase() === "scion") {
          if (colorCode.length) {
            colorCode = colorCode.slice(-3);
          }
        }

        // If colorCode was decoded successfully, we can set this bool to true in order update the decodedByBumper value in localstorage 
        if (colorCode.length > 0) {
          decodedByBumper = true;
        }
      } else {
        response = await fetch(
          "https://garage-vin-service-node-740168228309.us-east5.run.app/fetchVehicleData",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              vin: vin,
            }),
          }
        );

        if (!response.ok) {
          if (data.vehicleData.message === "Invalid vin") {
            validVin = false;
          }
          errorMessage = `Error fetching order details. Status: ${response.status}. Message: ${response.statusText}.`;
          throw new Error(
            `Error fetching order details. Status: ${response.status}. Message: ${response.statusText}.`
          );
        }

        data = await response.json();
        if (
          data.vehicleData.message ===
          "The VIN passed was modified to convert invalid characters"
        ) {
          errorMessage = `The VIN passed was modified to convert invalid characters.`;
          validVin = false;
        }

        dataResult = data.vehicleData.result;
        description = dataResult.exteriorColors[0]?.description || "";
        vehicleError = data.vehicleData.error || false;
        validVin = dataResult.validVin || false;
        exteriorColors = dataResult.exteriorColors || [];
        year = dataResult.year || "";
        make = dataResult.make || "";
        model = dataResult.model || "";
        submodel = data.submodel || "";
        engine = data.engine || "";
        ymm = `${year} ${make} ${model}`.trim();
        site = "ChromeData";
        styleId = dataResult.exteriorColors[0]?.styles[0] || "";
        genericDesc = dataResult.exteriorColors[0]?.genericDesc || "";
        fullDescription = dataResult.exteriorColors[0]?.description || "";
        hex = dataResult.exteriorColors[0]?.rgbHexValue || "";

        if (year !== "" && make !== "" && model !== "") {
          validVehicleFound = true;
        }

        if (exteriorColors.length === 1) {
          colorCode = exteriorColors[0]?.colorCode || "";

          // Toyota, Lexus, and Scion paint codes are always 3 digits but sometimes Bumper or Chromedata returns them as 4. 
          // e.g. Bumper === 0040, in reality it is 040.  So we take the last 3
          if (make.toLowerCase() === "toyota" || make.toLowerCase() === "lexus" || make.toLowerCase() === "scion") {
            colorCode = colorCode.slice(-3);
          }
        } else if (exteriorColors.length > 1) {
          errorMessage = `Too many paint codes to determine.`;
        }
      }
    } else {
      vehicleError = true;
      validVin = false;
    }

    // Garage
    if (functionLocation === 1) {
      let usedLicenseLookup = false;
      // If current vehicle is troublesome, we don't want to set the paint code at the garage level
      if (make.length && troublesomeMakesGlobal.includes(make.toLowerCase())) {
        isCurrentVehicleTroublesome = true;
        // If colorCode was decoded successfully and the current make is troublesome, ensure that decodedByBumper is false because we do not record
        // the paint code in this case
        if (colorCode.length > 0) {
          decodedByBumper = false;
        }
      }
      if (state && plate) {
        usedLicenseLookup = true;
      }

      if (validVehicleFound) {
        // Don't add garageVinSubmissionBool here because there will be a time when the button
        // is clickable between submission and page navigation.  Don't want anyone spamming
        // the button.
        if (!alreadyLogged) {
          logGarageEventToSheets("type", {
            vin: vin,
            plate: "",
            state: "",
            year: data.year,
            make: data.make,
            model: data.model,
            error: "",
            functionCall: "Garage VIN Submission",
          });
        } else {
          // If already logged, reset the flag so it can be logged again if needed.
          alreadyLogged = false;
        }

        if (allChromeDataMakes.includes(make.toLowerCase())) {
          chromedatamake = true;
        }

        let apiColorCode = '';

        // Being as how if it is not a bumperdotcommake, this function will resort to the `else`, it will attempt
        // to decode the paint with ChromeData, which could result in some wrong paint codes for those makes that are 
        // not chrome data makes.  Consequently, we specify here that in order to rely on the paint code returned
        // from either Bumper or Chromedata, the make itself must be associated with that api.  This allows us to
        // disable the bumperdotcommakes and not have them resort to decoding with chromedata
        if (chromedatamake) {
          apiColorCode = colorCode;
        } else if (bumperdotcommake) {
          apiColorCode = colorCode;
        }


        // Set the chromedataColorCode back to colorCode when wanting to implement
        // the colorCode back at the garage level to be stored in garage for more than just chromedata makes
        validVehicleFound = await updateGarageAndNavigate(
          year.toString(),
          make,
          model,
          submodel,
          engine,
          vin,
          apiColorCode,
          state,
          plate,
          decodedByBumper
        );
      }

      // validVehicleFound can change from true to false if updateGarageAndNavigate does not find a valid YMM in the easysearch dropdowns
      // Consequently, it must be treated as an invalid vehicle
      if (!validVehicleFound) {
        if (!alreadyLogged) {
          logGarageEventToSheets("type", {
            vin: vin,
            plate: "",
            state: "",
            year: "",
            make: "",
            model: "",
            error: "No vehicles found for the provided VIN.",
            functionCall: "Garage VIN Submission",
          });
        } else {
          // If already logged, reset the flag so it can be logged again if needed.
          alreadyLogged = false;
        }
        if (attemptedVinsInGarage.length < decodeMaxAttempts) {
          if (usedLicenseLookup) {
            errorMessageLicense.innerHTML = noResults;
            errorMessageLicense.style.visibility = "visible";
          } else {
            errorMessageVIN.innerHTML = noResults;
            errorMessageVIN.style.visibility = "visible";
          }
        } else {
          if (usedLicenseLookup) {
            errorMessageLicense.innerHTML = failed3times;
            errorMessageLicense.style.visibility = "visible";
            document.getElementById("license").disabled = true;
          } else {
            errorMessageVIN.innerHTML = failed3times;
            errorMessageVIN.style.visibility = "visible";
            document.getElementById("vin").disabled = true;
          }
          return;
        }
        garageVinSubmissionBool = false;
        return;
      }

      // Vin Verification
    } else if (functionLocation === 2) {
      if (data.handle === "" || data.isVinValid === false) {
        if (attemptedVinsVinVerification.length < decodeMaxAttempts) {
          document.querySelector(
            ".vin-verification-submission-failed-message"
          ).innerHTML = noResults;
          document.querySelector(
            ".vin-verification-remaining-attempts"
          ).style.display = "block";
          document.querySelector(
            ".vin-verification-remaining-attempts"
          ).innerHTML =
            remainingAttempts + calculatedRemainingAttemptsVinVerification;
        } else {
          document.querySelector(
            ".vin-verification-submission-failed-message"
          ).innerHTML = failed3times;
          document.getElementById("vin-textbox-for-verification").value = "";
          document.getElementById(
            "vin-textbox-for-verification"
          ).disabled = true;
          document.querySelector(
            ".vin-verification-remaining-attempts"
          ).style.display = "block";
          document.querySelector(
            ".vin-verification-remaining-attempts"
          ).innerHTML =
            remainingAttempts + calculatedRemainingAttemptsVinVerification;
          finalVinVerificationSubmissionVin = vin;
        }
        document.querySelector(
          ".vin-verification-submission-success-message"
        ).style.display = "none";
        document.querySelector(
          ".vin-verification-submission-failed-message"
        ).style.display = "block";
        return false;
      } else {
        document.querySelector(
          ".vin-verification-submission-success-message"
        ).innerHTML =
          tailoredSuccessMessage + `${data.year} ${data.make} ${data.model}`;
        document.querySelector(
          ".vin-verification-submission-failed-message"
        ).style.display = "none";
        document.querySelector(
          ".vin-verification-submission-success-message"
        ).style.display = "block";
        document.getElementById("vin-textbox-for-verification").disabled = true;
        document.querySelector(
          ".vin-verification-remaining-attempts"
        ).style.display = "none";

        finalVinVerificationSubmissionVin = vin;
        successfulVinVerificationVin = true;

        return true;
      }

      // Vin Decoder
    } else if (functionLocation === 3) {
      if (attemptedDecodedVins.length <= decodeMaxAttempts) {
        let troublesomeMake = false;
        if (Object.keys(troublesomeMakesColors).length > 0)
          troublesomeMake = true;

        if (vehicleError === false || validVin === true) {
          if (troublesomeMake === true) {
            const keys = Object.keys(troublesomeMakesColors);
            let matchedKey = keys.find((key) => {
              const colorArray = key.split(",").map((color) => color.trim()); // Trim spaces for clean comparison
              return colorArray.some((color) => color === description); // Check for an exact match
            });
            successfulVinDecoding = true;
            if (!matchedKey) {
              errorMessage = `Troublesome paintcode found: ${colorCode}. ${description} does not match any description in the metadata fields.`;
            }
            colorCode = matchedKey ? troublesomeMakesColors[matchedKey] : "";
            return { validVin: true, ymm: ymm, paintCode: colorCode || "", decodedByBumper: decodedByBumper };
          } else {
            successfulVinDecoding = true;
            return { validVin: true, ymm: ymm, paintCode: colorCode || "", decodedByBumper: decodedByBumper };
          }
        } else {
          if (errorMessage === "") {
            errorMessage = `Error fetching vehicle data.`;
          }
          document.querySelector(
            ".vin-decoder-submission-failed-message"
          ).innerHTML = noResults;
          document.querySelector(".vin-decoder-failed-attempt").style.display =
            "block";
          document.querySelector(".vin-decoder-failed-attempt").innerHTML =
            failedAttemptMsg + vin;
          document.querySelector(
            ".vin-decoder-remaining-attempts"
          ).style.display = "block";
          document.querySelector(".vin-decoder-remaining-attempts").innerHTML =
            remainingAttempts + calculatedRemainingAttemptsVinDecoder;
          return { validVin: false, ymm: "", paintCode: "", decodedByBumper: null };
        }
      } else {
        if (errorMessage === "") {
          errorMessage = `Failed 3 times. Error fetching vehicle data.`;
        }
        // Vin Decoder failed 3 times
        document.querySelector(
          ".vin-decoder-submission-failed-message"
        ).innerHTML = failed3times;
        document.querySelector(
          ".vin-decoder-submission-failed-message"
        ).style.display = "block";
        document.querySelector(".vin-decoder-failed-attempt").style.display =
          "block";
        document.querySelector(".vin-decoder-failed-attempt").innerHTML =
          failedAttemptMsg + vin;
        document.querySelector(
          ".vin-decoder-remaining-attempts"
        ).style.display = "block";
        document.querySelector(".vin-decoder-remaining-attempts").innerHTML =
          remainingAttempts + calculatedRemainingAttemptsVinDecoder;
        successfulVinDecoding = false;
        return { validVin: false, ymm: "", paintCode: "", decodedByBumper: null };
      }
    } else if (functionLocation === 4) {
      if (attemptedDecodedLicensePlates.length <= decodeMaxAttempts) {
        let troublesomeMake = false;
        if (Object.keys(troublesomeMakesColors).length > 0)
          troublesomeMake = true;

        if (vehicleError === false || validVin === true) {
          if (troublesomeMake === true) {
            const keys = Object.keys(troublesomeMakesColors);
            let matchedKey = keys.find((key) => {
              const colorArray = key.split(",").map((color) => color.trim()); // Trim spaces for clean comparison
              return colorArray.some((color) => color === description); // Check for an exact match
            });
            if (!matchedKey) {
              errorMessage = `Troublesome paintcode found: ${colorCode}. ${description} does not match any description in the metadata fields.`;
            }
            colorCode = matchedKey ? troublesomeMakesColors[matchedKey] : "";
            successfulVinDecoding = true;
            return { validVin: true, ymm: ymm, paintCode: colorCode || "", decodedByBumper: decodedByBumper };
          } else {
            successfulVinDecoding = true;
            return { validVin: true, ymm: ymm, paintCode: colorCode || "", decodedByBumper: decodedByBumper };
          }
        } else {
          if (errorMessage === "") {
            errorMessage = `Error fetching vehicle data.`;
          }
          document.querySelector(
            ".license-decoder-submission-failed-message"
          ).innerHTML = noResults;
          document.querySelector(
            ".license-decoder-failed-attempt"
          ).style.display = "block";
          document.querySelector(".license-decoder-failed-attempt").innerHTML =
            failedAttemptMsg + vin;
          document.querySelector(
            ".license-decoder-remaining-attempts"
          ).style.display = "block";
          document.querySelector(
            ".license-decoder-remaining-attempts"
          ).innerHTML =
            remainingAttempts + calculatedRemainingAttemptsLicenseDecoder;
          return { validVin: false, ymm: "", paintCode: "", decodedByBumper: null };
        }
      } else {
        if (errorMessage === "") {
          errorMessage = `Failed 3 times. Error fetching vehicle data.`;
        }
        document.querySelector(
          ".license-decoder-submission-failed-message"
        ).innerHTML = failed3times;
        document.querySelector(
          ".license-decoder-submission-failed-message"
        ).style.display = "block";
        document.querySelector(
          ".license-decoder-failed-attempt"
        ).style.display = "block";
        document.querySelector(".license-decoder-failed-attempt").innerHTML =
          failedAttemptMsg + vin;
        document.querySelector(
          ".license-decoder-remaining-attempts"
        ).style.display = "block";
        document.querySelector(
          ".license-decoder-remaining-attempts"
        ).innerHTML =
          remainingAttempts + calculatedRemainingAttemptsLicenseDecoder;
        successfulVinDecoding = false;
        return { validVin: false, ymm: "", paintCode: "", decodedByBumper: null };
      }
    }
  } catch (error) {
    if (functionLocation === 1) {
      let usedLicenseLookup = false;
      if (state && plate) {
        usedLicenseLookup = true;
      }
      if (usedLicenseLookup) {
        errorMessageLicense.innerHTML = noResults;
        errorMessageLicense.style.visibility = "visible";
        licenseToVinbtn.disabled = true;
        logGarageEventToSheets("type", {
          vin: vin,
          plate: plate,
          state: state,
          year: "",
          make: "",
          model: "",
          error: error.message,
          functionCall: "Garage VIN Submission",
        });
      } else {
        errorMessageVIN.innerHTML = noResults;
        errorMessageVIN.style.visibility = "visible";
        vinSearchBtn.disabled = true;
        logGarageEventToSheets("type", {
          vin: vin,
          plate: "",
          state: "",
          year: "",
          make: "",
          model: "",
          error: error.message,
          functionCall: "Garage VIN Submission",
        });
        if (attemptedVinsInGarage.length >= decodeMaxAttempts) {
          errorMessageVIN.innerHTML = failed3times;
          document.getElementById("vin").disabled = true;
          console.error("Error fetching vehicle data:", error);
          return;
        }
      }

      garageVinSubmissionBool = false;
    } else if (functionLocation === 2) {
      attemptedVinsVinVerification.push(vin);
      if (attemptedVinsVinVerification.length < decodeMaxAttempts) {
        document.querySelector(
          ".vin-verification-submission-failed-message"
        ).innerHTML = noResults;
        document.querySelector(
          ".vin-verification-remaining-attempts"
        ).style.display = "block";
        document.querySelector(
          ".vin-verification-remaining-attempts"
        ).innerHTML =
          remainingAttempts + calculatedRemainingAttemptsVinVerification;
      } else {
        document.querySelector(
          ".vin-verification-submission-failed-message"
        ).innerHTML = failed3times;
        document.getElementById("vin-textbox-for-verification").disabled = true;
        document.querySelector(
          ".vin-verification-remaining-attempts"
        ).style.display = "block";
        document.querySelector(
          ".vin-verification-remaining-attempts"
        ).innerHTML =
          remainingAttempts + calculatedRemainingAttemptsVinVerification;
        finalVinVerificationSubmissionVin = vin;
      }
      document.querySelector(
        ".vin-verification-submission-success-message"
      ).style.display = "none";
      document.querySelector(
        ".vin-verification-submission-failed-message"
      ).style.display = "block";
      console.error("Error fetching vehicle data:", error);
      return false;
    } else if (functionLocation === 3) {
      if (attemptedDecodedVins.length <= decodeMaxAttempts) {
        if (errorMessage === "") {
          errorMessage = `Error fetching vehicle data: ${error.message}`;
        }
        document.querySelector(
          ".vin-decoder-submission-failed-message"
        ).innerHTML = noResults;
        document.querySelector(".vin-decoder-failed-attempt").style.display =
          "block";
        document.querySelector(".vin-decoder-failed-attempt").innerHTML =
          failedAttemptMsg + vin;
        document.querySelector(
          ".vin-decoder-remaining-attempts"
        ).style.display = "block";
        document.querySelector(".vin-decoder-remaining-attempts").innerHTML =
          remainingAttempts + calculatedRemainingAttemptsVinDecoder;
      } else {
        if (errorMessage === "") {
          errorMessage = `Failed 3 times. Error fetching vehicle data: ${error.message}`;
        }
        document.querySelector(
          ".vin-decoder-submission-failed-message"
        ).innerHTML = failed3times;
        document.querySelector(
          ".vin-decoder-submission-failed-message"
        ).style.display = "block";
        document.querySelector(".vin-decoder-failed-attempt").style.display =
          "block";
        document.querySelector(".vin-decoder-failed-attempt").innerHTML =
          failedAttemptMsg + vin;
        document.querySelector(
          ".vin-decoder-remaining-attempts"
        ).style.display = "none";
        document.querySelector(".vin-decoder-remaining-attempts").innerHTML =
          remainingAttempts + calculatedRemainingAttemptsVinDecoder;
      }
      return { validVin: false, ymm: "", paintCode: "", decodedByBumper: null };
    } else if (functionLocation === 4) {
      if (attemptedDecodedLicensePlates.length <= decodeMaxAttempts) {
        if (errorMessage === "") {
          errorMessage = `Error fetching vehicle data: ${error.message}`;
        }
        document.querySelector(
          ".license-decoder-submission-failed-message"
        ).innerHTML = noResults;
        document.querySelector(
          ".license-decoder-failed-attempt"
        ).style.display = "block";
        document.querySelector(".license-decoder-failed-attempt").innerHTML =
          failedAttemptMsg + vin;
        document.querySelector(
          ".license-decoder-remaining-attempts"
        ).style.display = "block";
        document.querySelector(
          ".license-decoder-remaining-attempts"
        ).innerHTML =
          remainingAttempts + calculatedRemainingAttemptsLicenseDecoder;
      } else {
        if (errorMessage === "") {
          errorMessage = `Failed 3 times. Error fetching vehicle data: ${error.message}`;
        }
        document.querySelector(
          ".license-decoder-submission-failed-message"
        ).innerHTML = failed3times;
        document.querySelector(
          ".license-decoder-submission-failed-message"
        ).style.display = "block";
        document.querySelector(
          ".license-decoder-failed-attempt"
        ).style.display = "block";
        document.querySelector(".license-decoder-failed-attempt").innerHTML =
          failedAttemptMsg + vin;
        document.querySelector(
          ".license-decoder-remaining-attempts"
        ).style.display = "none";
        document.querySelector(
          ".license-decoder-remaining-attempts"
        ).innerHTML =
          remainingAttempts + calculatedRemainingAttemptsLicenseDecoder;
      }
      return { validVin: false, ymm: "", paintCode: "", decodedByBumper: null };
    }
    console.error("Error fetching vehicle data:", error);
  } finally {
    if (vinGuaranteeFetchingMsg) vinGuaranteeFetchingMsg.style.display = "none";
    if (vinDecoderFetchingMsg) vinDecoderFetchingMsg.style.display = "none";

    if (functionLocation === 1) {
      vinSearchBtn.classList.remove("vin-to-collection-btn--loading");
      vinSearchBtn.innerHTML = searchBtn;
    }

    if (functionLocation === 3 || functionLocation === 4) {
      decoderLoggerWebhook(
        state,
        plate,
        vin,
        site,
        year,
        make,
        model,
        styleId,
        colorCode,
        errorMessage,
        partifyLocation,
        parentUrl,
        genericDesc,
        fullDescription,
        hex
      );
    }
  }
}

// Uncomment the following function whenever we get more bumper credits
async function fetchBumpersLicenseToVin(state, plate) {
  try {
    alreadyLogged = false;
    const response = await fetch(
      `https://license-to-vin-273472976974.us-east5.run.app/license-to-vin?state=${state}&plate=${plate}`,
      {
        method: "Get",
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Error fetching order details. Status: ${response.status}. Message: ${response.statusText}.`
      );
    }
    const data = await response.json();
    const vin = data.entities?.vehicles?.automobiles[0]?.vin;
    const year = data.entities?.vehicles?.automobiles[0]?.year;
    const make = data.entities?.vehicles?.automobiles[0]?.make;
    const model = data.entities?.vehicles?.automobiles[0]?.model;

    if (data.entities?.vehicles?.automobiles.length > 0) {
      logGarageEventToSheets("type", {
        vin: vin,
        plate: plate,

        state: state,
        year: year,
        make: make,
        model: model,
        error: "",
        functionCall: "License To VIN",
      });
      alreadyLogged = true;
    } else {
      console.error("No vehicles found for the provided license plate.");
      document.getElementById("license-to-vin-btn").disabled = true;
      document.querySelector(".errorMessageLicense").style.visibility =
        "visible";
      document.querySelector(".errorMessageLicense").innerHTML =
        "No vehicles found for the provided license plate.";
      logGarageEventToSheets("type", {
        vin: vin,
        plate: plate,
        state: state,
        year: year,
        make: make,
        model: model,
        error: "No vehicles found for the provided license plate.",
        functionCall: "License To VIN",
      });
    }

    return { vin, year, make, model };
  } catch (error) {
    logGarageEventToSheets("type", {
      vin: vin,
      plate: plate,
      state: state,
      year: "",
      make: "",
      model: "",
      error: error.message,
      functionCall: "License To VIN",
    });
    document.getElementById("license-to-vin-btn").disabled = true;
    document.querySelector(".errorMessageLicense").style.visibility = "visible";
    document.querySelector(".errorMessageLicense").innerHTML =
      "Error fetching vehicle data. Please try again later.";
    console.error("Error fetching vehicle data:", error);
  }
}

async function handleVinDecode(
  vinInput,
  state,
  licensePlate,
  location,
  troublesomeMakesColors,
  bumperdotcommake,
  allChromeDataMakes,
  failed3timesmsg,
  noResults,
  searchBtn,
  tailoredSuccessMessage,
  failedAttemptMsg,
  remainingAttempts,
  vinDecoderFirstMsg,
  vinDecoderEndMsg,
  forceSelectMsgStart,
  forceSelectMsgEnd
) {
  let searchTerms = getSearchTerms();
  let exteriorColor = "";

  // Returns isVinValid and Paint code (if no paint code, returns empty string)
  const { validVin, ymm, paintCode, decodedByBumper } = await fetchVehicleDataByVin(
    state,
    licensePlate,
    vinInput,
    location,
    noResults,
    failed3timesmsg,
    searchBtn,
    tailoredSuccessMessage,
    failedAttemptMsg,
    remainingAttempts,
    troublesomeMakesColors,
    bumperdotcommake,
    allChromeDataMakes
  );
  if (validVin) {
    // Vin is valid and paint code is found
    const foundMatchingOption = handleAutoSelectColor(
      paintCode,
      vinInput,
      licensePlate,
      location,
      vinDecoderFirstMsg,
      vinDecoderEndMsg,
      forceSelectMsgStart,
      forceSelectMsgEnd
    );
    searchTerms[0].vin = vinInput;
    if (state) {
      searchTerms[0].state = state;
    }
    if (licensePlate) {
      searchTerms[0].plate = licensePlate;
    }
    if (foundMatchingOption) {
      searchTerms[0].paintCode = paintCode;
    }

    // Need this because may decode the paint code but did not find matching option
    // In here, will set the decodedByBumper......
    if (paintCode !== "") {
      if (Array.isArray(searchTerms) && searchTerms.length > 0) {
        const firstYMM = searchTerms[0].ymm || "";
        if (firstYMM === ymm) {
          searchTerms[0].paintCode = paintCode;
        }
      }
    }

    // If the paint code for the first vehicle (searchTerm) is the same as the paintCode returned from decoding,
    // we can safely set the decodedByBumper value
    if (searchTerms[0].paintCode === paintCode) {
      searchTerms[0].decodedByBumper = decodedByBumper;
    }

    setSearchTerms(searchTerms);
    window.GarageLogic.updateGaragePopup(getSearchTerms());
  } else {
    // Vin is not valid
  }

  return validVin;
}

function handleAutoSelectColor(
  paintCode,
  vinInput,
  licensePlate,
  location,
  decoderFirstMsg,
  decoderEndMsg,
  forceSelectMsgStart,
  forceSelectMsgEnd
) {
  const paintCodeWrapper = document.querySelector(".paint-code-wrapper");
  const paintcodeAppContainer = document.getElementById(
    "paintcode-app-container"
  );
  const variantSelector = document.getElementById("variant-selector");
  const paintedStockKeyLevel = document.querySelector(
    ".painted-stock-key-paint-level"
  );
  let matchingOption = false;

  if (variantSelector) {
    const options = Array.from(variantSelector.options);
    options.find((option) => {
      const codeInFrontOfPrice = option.label.split("+")[0];

      // In some instances, we have the same paint code but the color itself varies between years:
      // e.g. PBM (2006-2013) +$153.00 and PBM (2018-2023) +$153.00
      // if (codeInFrontOfPrice.includes("(")) {
      if (codeInFrontOfPrice.trim() === paintCode) {
        matchingOption = true;
        if (option.textContent.includes("🚚")) {
          decodedVINHasAvailableStock = true;
        }
        autoSelectedColor = option.value;
        autoSelectedOption = option;
        return true;
      }
    });

    if (matchingOption) {
      storedDecodedVin = vinInput;
      if (autoSelectedOption.dataset.unavailable === "true") {
        autoSelectedBanned = true;
      }
      variantSelector.value = autoSelectedColor;
      document.body.classList.remove("no-scroll-paint-swatch");
      if (window.enablePrepaintedMessaging) {
        if (decodedVINHasAvailableStock) {
          paintedStockKeyLevel.style.display = "block";
        }
      }
      if (!autoSelectedBanned) {
        // Create a new message to indicate the selected VIN
        if (location === 3) {
          const vinMessage = document.createElement("div");
          vinMessage.className = "vin-decoder-message";
          vinMessage.style.display = "block";
          vinMessage.innerHTML = `
                          <strong style="color: #444;">${decoderFirstMsg}</strong>
                          <span style="color: #000; font-weight: 800;">${vinInput},</span>
                          <span style="color: #444;">${decoderEndMsg}</span>
                          <span style="color: #000; font-weight: 800;">${paintCode}</span>
                      `;
          if (paintCodeWrapper) paintCodeWrapper.appendChild(vinMessage);
        }

        if (location === 4) {
          const vinMessage = document.createElement("div");
          vinMessage.className = "license-decoder-message";
          vinMessage.style.display = "block";
          vinMessage.innerHTML = `
                          <strong style="color: #444;">${decoderFirstMsg}</strong>
                          <span style="color: #000; font-weight: 800;">${licensePlate},</span>
                          <span style="color: #444;">${decoderEndMsg}</span>
                          <span style="color: #000; font-weight: 800;">${paintCode}</span>
                      `;
          if (paintCodeWrapper) paintCodeWrapper.appendChild(vinMessage);
        }
      }
      // Trigger the change event programmatically
      variantSelector.dispatchEvent(new Event("change", { bubbles: true }));
      if (typeof vinInputLibrary !== "undefined" && vinInputLibrary) {
        vinInputLibrary.value = vinInput;
      }
    } else {
      resortToForceSelectCode();
      formulateForcePaintCodeSelectMsg(
        vinInput,
        licensePlate,
        forceSelectMsgStart,
        forceSelectMsgEnd,
        location
      );
      console.warn(
        `No matching option found for paint code: ${paintCode} using the vin: ${vinInput}`
      );
    }
  } else {
    console.warn("Variant selector dropdown not found.");
  }
  if (location === 3) {
    const paintCodeAppContainer = document.getElementById(
      "paintcode-app-container"
    );
    if (paintCodeAppContainer) paintCodeAppContainer.classList.remove("show");
  }

  if (location === 4) {
    const paintCodeAppContainerLicense = document.getElementById(
      "paintcode-app-container-license"
    );
    if (paintCodeAppContainerLicense)
      paintCodeAppContainerLicense.classList.remove("show");
  }

  if (paintCodeWrapper) paintCodeWrapper.classList.add("show");

  return matchingOption;
}

function handleInsertLocalStoragePaintOption() {
  const garageSearchTerms = getSearchTerms();
  let firstItemColor = "";
  let firstItemState = "";
  let firstItemPlate = "";
  let firstItemVin = "";
  let foundMatchingColor = false;
  if (garageSearchTerms && garageSearchTerms.length) {
    firstItemColor = garageSearchTerms[0]?.paintCode;
    firstItemState = garageSearchTerms[0]?.state;
    firstItemPlate = garageSearchTerms[0]?.plate;
    firstItemVin = garageSearchTerms[0]?.vin;

    // If the color exists in local storage
    if (firstItemColor) {
      const allVariantOptions = window.productVariants;

      // Set sampleArrToCheck to the first existing array within window.productVariants (NOTE: all product qualities should have the same
      // paint variants)
      const sampleArrToCheck =
        allVariantOptions.aftermarket ||
        allVariantOptions.capa ||
        allVariantOptions.oem ||
        allVariantOptions.current;
      for (let i = 0; i < sampleArrToCheck.length; i++) {
        const option = sampleArrToCheck[i];

        if (firstItemColor === option.variantTitle) {
          decodedPaintedOptionPrice = (
            option.priceDifference / 100
          ).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
          foundMatchingColor = true;

          // If the variant is difficult to match and a disclaimer must be show, set the storedPaintOptionsIsDTM flag
          if (
            option.variantAvailable === "true" ||
            option.variantAvailable === true
          ) {
            storedPaintOptionIsDTM = true;
          }
        }
      }

      // If the color stored in local storage is found to match a variant option, display matching option and hide VIN and license option
      if (foundMatchingColor) {
        storedOptionLabel.style.display = "block";
        failSafeSelectCodeOptionLabel.style.display = "block";
        selectCodeOptionLabel.style.display = "none";
        // Formats the checkbox to look like: "Painted [color] +[price]"
        if (decodedPaintedOptionPrice.length) {
          checkboxStoredCodeText.innerHTML =
            decodedPaintedOptionPainted +
            " " +
            firstItemColor +
            " +" +
            decodedPaintedOptionPrice;
        } else if (decodedPaintedOptionPrice.length === 0) {
          checkboxStoredCodeText.innerHTML =
            decodedPaintedOptionPainted + " " + firstItemColor;
        }

        // If both state and plate exist in local storage, render the paint option message accordingly
        if (firstItemState && firstItemPlate) {
          const localStatePlate = firstItemState + "-" + firstItemPlate;
          displayStoredPaintCodeMsg(false, localStatePlate, firstItemColor);

          // If no state or plate exist but a vin does, render the paint option accordingly
        } else if (firstItemVin) {
          const localVin = firstItemVin;
          displayStoredPaintCodeMsg(true, localVin, firstItemColor);
        }
        if (vinOptionLabel) {
          vinOptionLabel.style.display = "none";
        }
        if (licenseOptionLabel) {
          licenseOptionLabel.style.display = "none";
        }

        // If the color stored in local storage does not match a variant option, just hide VIN and license option
      } else {
        if (vinOptionLabel) {
          vinOptionLabel.style.display = "none";
        }
        if (licenseOptionLabel) {
          licenseOptionLabel.style.display = "none";
        }
      }

      // If vehicle exists in garage but does not have a color associated with it yet,
      // ensure the VIN and license options are displayed
    } else {
      if (vinOptionLabel) {
        vinOptionLabel.style.display = "block";
      }
      if (licenseOptionLabel) {
        licenseOptionLabel.style.display = "block";
      }
    }
  }

  return firstItemColor;
}

function displayStoredPaintCodeMsg(isVin, vinOrLicense, color) {
  storedDecodedPaintCodeMsgGlobal.style.display = "block";
  const licenseOrVinSpan = document.querySelector(
    ".stored-paint-code-license-or-vin"
  );
  const colorSpan = document.querySelector(".stored-paint-code-color");

  if (isVin) {
    licenseOrVinSpan.textContent = vinWord + " " + vinOrLicense + ",";
  } else {
    licenseOrVinSpan.textContent = licensePlateWord + " " + vinOrLicense + ",";
  }
  colorSpan.textContent = color + ".";
}

function resortToForceSelectCode() {
  const paintCodeWrapper = document.querySelector(".paint-code-wrapper");
  const paintCodeCheckbox = document.getElementById(
    "checkbox-select-paint-option"
  );
  paintCodeWrapper.classList.add("show");
  paintCodeCheckbox.checked = true;

  // Hide both checkboxes if they exist
  const vinCheckboxLabel = document
    .querySelector("input#checkbox-get-paint-code-with-vin")
    ?.closest("label");
  if (vinCheckboxLabel) vinCheckboxLabel.style.display = "none";

  const licenseCheckboxLabel = document
    .querySelector("input#checkbox-get-paint-code-with-license")
    ?.closest("label");
  if (licenseCheckboxLabel) licenseCheckboxLabel.style.display = "none";
}

function formulateForcePaintCodeSelectMsg(
  vin,
  licensePlate,
  forceSelectMsgStart,
  forceSelectMsgEnd,
  location
) {
  const vinDecoderMessage = document.querySelector(".vin-decoder-message");
  if (!vinDecoderMessage) {
    const paintCodeWrapper = document.querySelector(".paint-code-wrapper");
    // const existingMessage = vinTextboxContainer.querySelector('.vin-selected-message');
    // vinTextboxContainer.style.display = "block";

    // // Remove any existing message to avoid duplication
    // if (existingMessage) {
    //   existingMessage.remove();
    // }

    // Create a new message to indicate the selected VIN
    const vinMessage = document.createElement("div");
    vinMessage.className = "vin-decoder-message resort-to-force-select";
    vinMessage.style.display = "block";
    if (location === 3) {
      vinMessage.innerHTML = `
        <strong style="color: #444;">${forceSelectMsgStart}</strong> 
        <span style="color: #000; font-weight: 800;">${vin}.</span> 
        <span style="color: #444;">${forceSelectMsgEnd}</span> 
      `;
    }

    if (location === 4) {
      vinMessage.innerHTML = `
        <strong style="color: #444;">${forceSelectMsgStart}</strong> 
        <span style="color: #000; font-weight: 800;">${licensePlate}.</span> 
        <span style="color: #444;">${forceSelectMsgEnd}</span> 
      `;
    }
    vinMessage.style.backgroundColor = "#ffbc2c17";
    vinMessage.style.border = "1px solid #ffae00";

    failedVinDecode = true;

    // Append the message to the VIN textbox container
    paintCodeWrapper.appendChild(vinMessage);
  }
}

async function decoderLoggerWebhook(
  state,
  plate,
  vin,
  site,
  year,
  make,
  model,
  styleId,
  code,
  error,
  partifyLocation,
  parentUrl,
  genericDesc,
  fullDescription,
  hex
) {
  try {
    const response = await fetch(
      "https://script.google.com/macros/s/AKfycbwMc2VFphCTCLkGPdPWQ7IvBPOXFOqNIJOyNgGKiSOQzog5rLcvDyGT7VxcPw49L53T4Q/exec",
      {
        redirect: "follow",
        method: "POST",
        headers: {
          "Content-Type": "text/plain;charset=UTF-8",
        },
        body: JSON.stringify({
          state: state,
          plate: plate,
          vin: vin,
          site: site,
          year: year,
          make: make,
          model: model,
          styleId: styleId,
          code: code,
          error: error,
          themeName: themeName,
          partifyLocation: partifyLocation,
          parentUrl: parentUrl,
          genericDesc: genericDesc,
          fullDescription: fullDescription,
          hex: hex,
        }),
      }
    );

    // If the response is not JSON, log it as text to debug
    const text = await response.text();
    // Try parsing the JSON only if the response status is OK
    if (response.ok) {
      const result = JSON.parse(text);
      return result;
    } else {
      console.error("Server responded with an error:", text);
    }
  } catch (error) {
    console.error("Error submitting logs:", error);
  }
}

async function logGarageEventToSheets(logWay, payload, ...rest) {
  let endpoint = "";
  try {
    // Optionally add timestamp if not present
    if (logWay === "dropdown") {
      const raw = localStorage.getItem("searchTerms");

      if (raw) {
        const parseData = JSON.parse(raw);
        if (Array.isArray(parseData) && parseData.length > 0) {
          payload.year = parseData[0].year || "";
          payload.make = parseData[0].make || "";
          payload.model = parseData[0].model || "";
          payload.submodel = parseData[0].submodel || "";
          payload.engine = parseData[0].engine || "";
          payload.currentPage = parseData[0].currentPage || "";
        }
      }
      endpoint =
        " https://script.google.com/macros/s/AKfycbyjNiscdz6IF6kIXMBi2DbT7g8yY16iBVg75x0gQHVc8ju8HXHGPCisOzIut8Q4VCDHpw/exec";
    }

    // Optionally add themeName and partifyLocation if available
    if (logWay === "type") {
      if (typeof themeName !== "undefined" && themeName && !payload.themeName) {
        payload.themeName = themeName;
      }
      if (
        typeof getPartifyLocation === "function" &&
        !payload.partifyLocation
      ) {
        const loc = await getPartifyLocation();
        payload.partifyLocation = loc;
      }
      endpoint =
        "https://script.google.com/macros/s/AKfycbwCZ8V4gzHelwgcdARADTgoze6bK-VKJYViFH2FgrrPslPZAaPdweVeVTgeWmEqgtOFgg/exec";
    }

    const response = await fetch(endpoint, {
      redirect: "follow",
      method: "POST",
      headers: {
        "Content-Type": "text/plain;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    });
    const text = await response.text();
    if (response.ok) {
      try {
        return JSON.parse(text);
      } catch (e) {
        return text;
      }
    } else {
      console.error("Server responded with an error:", text);
    }
  } catch (error) {
    console.error("Error submitting logs:", error);
  }
}

async function getPartifyLocation() {
  const ip = await getIpAddress();

  let partifyLocation = "";
  if (ip === "107.5.210.48") {
    partifyLocation = "Warren";
  } else if (
    ip === "98.209.126.177" ||
    ip === "68.34.24.103" ||
    ip === "68.34.24.104"
  ) {
    partifyLocation = "Fraser";
  }

  return partifyLocation;
}

function toggleProductDoesNotFitMsg(doesNotFit) {
  let vehicleList = document.querySelector(".vehicle-list");
  if (vehicleList) {
    let failToFitMsg = document.querySelector(
      ".product-does-not-fit-garage-msg"
    );
    if (!failToFitMsg) {
      failToFitMsg = document.createElement("div");
      failToFitMsg.className = "product-does-not-fit-garage-msg";
      failToFitMsg.textContent = "";
      vehicleList.parentNode.insertBefore(failToFitMsg, vehicleList);
    }
    if (!doesNotFit) {
      failToFitMsg.style.display = "none";
    } else {
      failToFitMsg.style.display = "block";
    }
  }
}

function toggleGaragePopup() {
  // Always select the popup regardless of hidden state
  let garageEasyPopup = document.querySelector(".garage-easyYMM-popup");
  if (!garageEasyPopup) {
    console.error("No .garage-easyYMM-popup element found!");
    return;
  }

  const garagePopupStyleId = "garage-popup-style";
  const scrollY = window.scrollY;

  garageEasyPopup.classList.toggle("hidden");

  if (!garageEasyPopup.classList.contains("hidden")) {
    document.body.dataset.scrollY = scrollY;

    if (!document.getElementById(garagePopupStyleId)) {
      const style = document.createElement("style");
      style.id = garagePopupStyleId;
      style.textContent = `
            body.no-scroll-garage-popup {
              position: fixed;
              top: -${scrollY}px;
              left: 0;
              width: 100%;
              height: 100%;
              overflow: hidden !important;
            }
          `;
      document.head.appendChild(style);
    }
    document.body.classList.add("no-scroll-garage-popup");
    hideShopifyChat();
  } else {
    const savedScrollY = parseInt(document.body.dataset.scrollY || "0", 10);
    delete document.body.dataset.scrollY;

    let terms = JSON.parse(localStorage.getItem("searchTerms")) || [];
    if (
      document.getElementById("add-vehicle-btn").style.display === "none" &&
      terms.length > 0
    ) {
      const garagePopupContainer = document.querySelector(
        ".garage-easyYMM-popup-container"
      );
      garagePopupContainer.querySelector(".easyYMM").style.display = "none";
      document.getElementById("vin-to-collection-placeholder").style.display =
        "none";
      document.getElementById("vin-to-collection-or").style.display = "none";
      if (garagePopupContainer) {
        garagePopupContainer.classList.remove("no-bottom-radius");
      }
      document.getElementById("add-vehicle-btn").style.display = "flex";
      document.querySelector(".garage-block").style.display = "block";
      document.querySelector(".select-your-vehicle-header").style.display =
        "none";
    }
    const style = document.getElementById(garagePopupStyleId);
    if (style) {
      style.remove();
    }

    window.scrollTo(0, savedScrollY);
    showShopifyChat();
  }
}

function generateCollectionHandle(vehicleData) {
  let collectionHandle = vehicleData
    .toLowerCase()
    .replace(/\./g, "-")
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/-+$/, "");

  return collectionHandle;
}

function openQuestionModal({
  scrollLockClass = "no-scroll-paint-swatch",
  accordionSelector = ".accordion-section",
  overlaySelector = ".product-unfolded-popup-dark-overlay",
  modalSelector = ".unfolded-popup-container",
  modalContentSelector = ".popup-modal-content",
  fetchContentFn = null, // async function to fetch content, if needed
}) {
  // Save scroll position globally
  // window.paintModalScrollPosition = window.scrollY || document.documentElement.scrollTop;

  // Optionally expand accordions
  if (accordionSelector) {
    const accordionSections = document.querySelectorAll(accordionSelector);
    accordionSections.forEach((section) => {
      const content = section.querySelector(".accordion-content");
      const circlePlus = section.querySelector(".circle_plus");
      const circleNone = section.querySelector(".circle_none");
      const isOpen = content.classList.contains("open");
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (!isOpen) {
            content.classList.add("open");
            content.style.maxHeight = content.scrollHeight + "px";
            if (circlePlus) circlePlus.style.display = "none";
            if (circleNone) circleNone.style.display = "block";
          }
        }, 500);
      });
    });
  }

  // Lock scroll
  document.body.classList.add(scrollLockClass);

  // Hide Shopify chat
  if (typeof hideShopifyChat === "function") hideShopifyChat();

  // Show overlay
  if (overlaySelector) {
    const overlay = document.querySelector(overlaySelector);
    if (overlay) overlay.style.display = "block";
  }

  // Show modal and set content
  if (modalSelector) {
    document.querySelector(modalSelector).style.display = "block";
  }
  if (fetchContentFn && modalContentSelector) {
    fetchContentFn()
      .then((pageContent) => {
        document.querySelector(modalContentSelector).innerHTML = pageContent;
      })
      .catch((error) => {
        console.error("Error fetching modal content:", error);
      });
  }
}

function showQuestionModal(
  content,
  showContent,
  modalElement,
  containerElement
) {
  const modalContent = document.querySelector(modalElement);
  if (showContent) {
    modalContent.innerHTML = content;
  }
  document.querySelector(containerElement).style.display = "block";
}

function closeQuestionModal(
  noScrollElement,
  scrollPosition,
  containerElement,
  modalElement,
  overlayElement
) {
  // Remove scroll lock and restore scroll position
  document.body.classList.remove(noScrollElement);
  window.scrollTo(0, scrollPosition); // Restore scroll position

  // Show Shopify chat and hide overlay
  showShopifyChat();
  hideQuestionModalOverlay(overlayElement);
  hideQuestionModal(containerElement, modalElement);
}

function hideQuestionModal(containerElement, modalElement) {
  const container = document.querySelector(containerElement);
  const modal = document.querySelector(modalElement);
  const onAnimationEnd = function () {
    modal.style.animation = "";
    container.style.display = "none";
    modal.removeEventListener("animationend", onAnimationEnd);
  };

  modal.style.animation = "drop-out 0.3s forwards";
  modal.addEventListener("animationend", onAnimationEnd);
}

function hideQuestionModalOverlay(overlayElement) {
  document.querySelector(overlayElement).style.display = "none";
}

function showQuestionModalOverlay(overlayElement) {
  document.querySelector(overlayElement).style.display = "block";
}

function accordionButtonHandle(button, section) {
  const accordionSection = button.closest(section);
  const content = accordionSection.querySelector(".accordion-content");
  const circlePlus = accordionSection.querySelector(".circle_plus");
  const circleNone = accordionSection.querySelector(".circle_none");

  // Check if the clicked accordion is already open
  const isOpen = content.classList.contains("open");

  if (isOpen) {
    // Open the clicked accordion
    content.classList.remove("open");
    content.style.maxHeight = 0;

    // Show the minus icon and hide the plus icon for the active accordion
    circlePlus.style.display = "block";
    circleNone.style.display = "none";
  }

  if (!isOpen) {
    // Open the clicked accordion
    content.classList.add("open");
    content.style.maxHeight = content.scrollHeight + "px";

    // Show the minus icon and hide the plus icon for the active accordion
    circlePlus.style.display = "none";
    circleNone.style.display = "block";
  }
}

function hideShopifyChat() {
  const shopifyChat = document.getElementById("shopify-chat");
  if (shopifyChat) {
    shopifyChat.style.display = "none";
  }
}

// Function to show Shopify chat widget
function showShopifyChat() {
  const shopifyChat = document.getElementById("shopify-chat");
  if (shopifyChat) {
    shopifyChat.style.display = "block";
  }
}

async function fetchVehicalDataFromBumper(vin) {
  try {
    const response = await fetch(
      `https://bumperdotcom-api-345230973812.us-east5.run.app/bumperdotcom-api?vin=${vin}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    data = await response.json();

    if (!response.ok) {
      throw new Error(
        `Error fetching order details. Status: ${response.status}`
      );
    }
  } catch (error) {
    console.error("Error fetching vehicle data:", error);
  }
}
